import { AIDesignerBody } from "@/pages/AIDesignerPage";

const AdminAIDesigner = () => (
  <div data-testid="admin-ai-designer-page">
    <AIDesignerBody
      heading="Generate a design for a customer"
      subheading="Use this for walk-ins or to prepare a concept for customer approval before production. Each generation is logged."
    />
  </div>
);

export default AdminAIDesigner;
